<!--Main outlet-->
<!-- splash -->
<div class="splash-screen">
  <img [src]="(config$ | async)?.uiConfiguration?.logoImage" />
  <div class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
  </div>
</div>

<app-driveb-loading-driveb></app-driveb-loading-driveb>

<router-outlet></router-outlet>
